var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShareBorderBold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icShare") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guest",
    transform: "translate(-293.000000, -370.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(5.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(238.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(12.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icShare",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19624317,6.80072207 L10.7586004,4.23836483 L10.7586004,17.7931151 C10.7586004,18.4787087 11.3143838,19.0344921 11.9999774,19.0344921 C12.685571,19.0344921 13.2413544,18.4787087 13.2413544,17.7931151 L13.2413544,4.23836483 L15.8037116,6.80072207 C16.1170274,7.11574662 16.5748163,7.23930072 17.0040864,7.12469509 C17.4333565,7.01008946 17.7686446,6.67480135 17.8832503,6.24553122 C17.9978559,5.8162611 17.8743018,5.35847227 17.5592773,5.04515641 L12.8777861,0.363613514 C12.6449809,0.130796337 12.3292221,0 11.9999774,0 C11.6707327,0 11.3549739,0.130796337 11.1221687,0.363613514 L6.44067752,5.04515641 C6.12565297,5.35847227 6.00209887,5.8162611 6.1167045,6.24553122 C6.23131013,6.67480135 6.56659824,7.01008946 6.99586836,7.12469509 C7.42513849,7.23930072 7.88292732,7.11574662 8.19624317,6.80072207 L8.19624317,6.80072207 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7585778,10.7586456 C22.0729842,10.7586456 21.5172008,11.314429 21.5172008,12.0000226 L21.5172008,21.5172461 L2.48275394,21.5172461 L2.48275394,12.0000226 C2.48275394,11.314429 1.92697054,10.7586456 1.24137697,10.7586456 C0.555783401,10.7586456 0,11.314429 0,12.0000226 L0,21.9310384 C0,23.0736943 0.926305668,24 2.06896162,24 L21.9309931,24 C23.0736491,24 23.9999548,23.0736943 23.9999548,21.9310384 L23.9999548,12.0000226 C23.9999548,11.314429 23.4441714,10.7586456 22.7585778,10.7586456 L22.7585778,10.7586456 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareBorderBold);
export default __webpack_public_path__ + "static/media/icShareBorderBold.de843f2c318771fe16010b08538c004c.svg";
export { ForwardRef as ReactComponent };